import { ExtensibleObject } from '../types';

export const EMPTY_ARRAY = Object.freeze([]) as unknown as Readonly<any[]>;
export const EMPTY_OBJECT = Object.freeze({}) as Readonly<ExtensibleObject>;
